const EST_SHIPPING_KEY = 'EST_SHIPPING_DATA_NEW';
const EST_SHIPPING_URL = 'https://cdn.shopify.com/s/files/1/0949/1454/3899/files/est-shipping-data.json?v=1750920940';
const MONTH_NAMES_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

async function getEstimateShippingData() {
  let estShippingData = localStorage.getItem(EST_SHIPPING_KEY);
  const isDataShippingExpired = estShippingData ? new Date() > new Date(estShippingData.expirationDay) : true;
  if (isDataShippingExpired) {
    const response = await fetch(EST_SHIPPING_URL);
    if (!response.ok) {
      console.error('Could not fetch data');
      return;
    }
    const estShippingData = await response.json();
    if (estShippingData) {
      localStorage.setItem(EST_SHIPPING_KEY, JSON.stringify(estShippingData));
    }
  }
  return JSON.parse(localStorage.getItem(EST_SHIPPING_KEY));
}

function openModalEstShipping() {
  const modalDelivery = document.querySelector('#modal-delivery');
  const elePopUpShipping = document.querySelector('#popup-shipping');
  const eleDeliveredDay = document.querySelector('#delivered-day');
  const eleBtnCloseDelivered = document.querySelector('#btn-mobi-close-delivered');
  if (window.matchMedia('(max-width: 768px)').matches) {
    eleDeliveredDay.addEventListener('click', () => {
      modalDelivery.classList.remove('wp-hidden');
    });
    eleBtnCloseDelivered.addEventListener('click', () => {
      modalDelivery.classList.add('wp-hidden');
    });
    modalDelivery.addEventListener('click', function (event) {
      if (event.target == modalDelivery) {
        modalDelivery.classList.add('wp-hidden');
      }
    });
  } else {
    eleDeliveredDay.addEventListener('mouseover', () => {
      eleDeliveredDay.classList.add('wp-cursor-pointer');
      elePopUpShipping.classList.remove('wp-hidden');
    });
    eleDeliveredDay.addEventListener('mouseout', () => {
      eleDeliveredDay.classList.add('wp-cursor-pointer');
      elePopUpShipping.classList.add('wp-hidden');
    });
  }
}

Date.prototype.addDays = function (days) {
  const date = new Date(this);
  date.setDate(this.getDate() + days);
  return date;
};

function getMonthNames() {
  return MONTH_NAMES_SHORT;
}

function formatDateRange(startDate, endDate, monthNames) {
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();
  if (startMonth === endMonth) {
    return `${monthNames[startMonth]} ${startDate.getDate()} - ${endDate.getDate()}`;
  }
  return `${monthNames[startMonth]} ${startDate.getDate()} - ${monthNames[endMonth]} ${endDate.getDate()}`;
}

function calculateShippingDates(product, orderHandlingTime, orderShippingTime, country) {
  const { title: productTitle, type: productType } = product;
  let handlingTimeConfig = orderHandlingTime[productType?.toLowerCase()];
  
  const monthNames = getMonthNames();
  if (!handlingTimeConfig) {
    handlingTimeConfig = orderHandlingTime.default;
  }

  const today = new Date();

  let handlingTimeText = '';

  let shippingTimeText = '';
  let handlingData = null;

  for (const keyword in handlingTimeConfig) {
    if (!productTitle.toLowerCase().includes(keyword)) continue;
    handlingData = handlingTimeConfig[keyword];
    break;
  }
  if(!handlingData && handlingTimeConfig?.default){
    handlingData = handlingTimeConfig.default
  }
  if (!handlingData) {
    let defaultHandlingTime = orderHandlingTime.default;
    handlingData = defaultHandlingTime.other;
  }

  const minHandlingTime = today.addDays(+handlingData.min);
  const maxHandlingTime = today.addDays(+handlingData.max);
  handlingTimeText = formatDateRange(minHandlingTime, maxHandlingTime, monthNames);

  let shippingConfig = orderShippingTime[handlingData.type];
  if (!shippingConfig) {
    shippingConfig = orderShippingTime.default;
  }

  let shippingData = shippingConfig[country.toLowerCase()];
  if (!shippingData) {
    shippingData = shippingConfig.default;
  }

  const minShippingTime = minHandlingTime.addDays(+shippingData.min);
  const maxShippingTime = maxHandlingTime.addDays(+shippingData.max);
  shippingTimeText = formatDateRange(minShippingTime, maxShippingTime, monthNames);

  const estShipDateElement = document.querySelector('.est-shipping-date');
  if (estShipDateElement) {
    estShipDateElement.textContent = `${shippingTimeText}`;
  }

  return {
    orderPlaced: `${monthNames[today.getMonth()]} ${today.getDate()}`,
    shipDay: handlingTimeText,
    deliveredDay: shippingTimeText,
  };
}

function estShipping(countryCode, data) {
    const product = window.tfxProduct;
    const { orderHandlingTime, orderShippingTime } = window.estimateShipping;
    const { fulfillments, estShipping, productInfo } = data;
  
    const resEstV2 = calculateShippingDates(product, orderHandlingTime, orderShippingTime, countryCode);
  
    if (resEstV2) {
      return resEstV2;
    }
  
    const resEstV1 = calculateEstimateShippingWithCountry(
      countryCode,
      fulfillments,
      estShipping,
      productInfo
    );
    return resEstV1.estimateShippingTime;
  }  


document.addEventListener('DOMContentLoaded', () => {
  openModalEstShipping();
});
